import { INIT_PAGE_STATE } from "../../constant/constant";

export const SETTING_GET_LIST = "SETTING_GET_LIST";
export const SETTING_GET_LIST_SUCCESS = "SETTING_GET_LIST_SUCCESS";
export const SETTING_GET_LIST_ERROR = "SETTING_GET_LIST_ERROR";
export const SETTING_LOAD_ONE = "SETTING_LOAD_ONE";
export const SETTING_ADD_EDIT = "SETTING_ADD_EDIT";
export const SETTING_SAVE_ADD_EDIT = "SETTING_SAVE_ADD_EDIT";
export const SETTING_SAVE_ADD_EDIT_SUCCESS = "SETTING_SAVE_ADD_EDIT_SUCCESS";
export const SETTING_SAVE_ADD_EDIT_ERROR = "SETTING_SAVE_ADD_EDIT_ERROR";

export const loadSetting = (p) => {
  const param = {
    ...{
      selectedPage: 1,
      filter: null,
      orderBy: "createTime",
      sortedBy: "desc",
      limit: INIT_PAGE_STATE.pageSizes[0],
      // limit: 3,
    },
    ...p,
  };
  return {
    type: SETTING_GET_LIST,
    payload: {
      municipal_id: param?.sourced_id,
      selectedPage: param.selectedPage,
      filter: param.filter,
      orderBy: param.orderBy,
      sortedBy: param.sortedBy,
      limit: param.limit,
      municipal_name: param.municipal_name,
    },
  };
};

export const loadSettingSuccess = (data) => ({
  type: SETTING_GET_LIST_SUCCESS,
  payload: data,
});

export const loadSettingError = (error) => ({
  type: SETTING_GET_LIST_ERROR,
  payload: error,
});

export const loadSettingOne = () => ({
  type: SETTING_LOAD_ONE,
});

export const addEditSetting = (item, mode = "add") => ({
  type: SETTING_ADD_EDIT,
  payload: {
    item,
    mode,
  },
});

export const saveAddEditSetting = (item, mode = "add", history) => ({
  type: SETTING_SAVE_ADD_EDIT,
  payload: {
    item,
    mode,
    history,
  },
});

export const saveAddEditSettingSuccess = (data) => ({
  type: SETTING_SAVE_ADD_EDIT_SUCCESS,
  payload: data,
});

export const saveAddEditSettingError = (error) => ({
  type: SETTING_SAVE_ADD_EDIT_ERROR,
  payload: error,
});
